<template>
    <div class="date-calendar">
        <header>
            <div class="date-calendar-header flex">
                <div class="date-calendar-header-month" @click="prev()">
                    <i class="icon-angle-left"></i> {{monthInfo.prevMonth}}月
                </div>
                <div class="date-calendar-header-title">
                    {{tagDay|date('yyyy年MM月')}}
                    <label v-if="(!readonly || isTuan) && !single">
                        <input type="checkbox"
                               @change="selectAll()"
                               :checked="isAllChecked()"
                               v-model="allChecked">
                        全选
                    </label>
                    <button class="btn btn-primary btn-sm" style="margin-left: 20px"
                            v-if="!readonly && !removeDisabled"
                            type="button"
                            @click="removeSelect()">
                        删除选中日期
                    </button>
                </div>
                <div class="date-calendar-header-month" @click="next()">
                    {{monthInfo.nextMonth}}月 <i class="icon-angle-right"></i>
                </div>
            </div>
            <div class="date-calendar-week-line flex">
                <div v-for="item in weekdays" class="date-calendar-week-title" :key="item.index">
                    <label>
                        <input type="checkbox"
                               v-if="(!readonly || isTuan) && !single"
                               :checked="isWeekAllSelected(item)"
                               v-model="item.checked" @change="selectWeek(item.index, item.checked)"/>
                        周{{item.name}}
                    </label>
                </div>
            </div>
        </header>
        <section class="date-calendar-body">
            <div class="date-calendar-line flex" v-for="week in weeks">
                <!--<day class="date-calendar-day" :day="day" v-for="day in week"></day>-->
                <div class="date-calendar-day" v-for="day in week"
                     :class="{selected:day.checked, other: day.otherMon, locked: day.locked, today:day.isToday, info:day.info, 'out-range':day.isBefore||day.isAfter}"
                     @click="toggle(day)">
                    <div class="day-text">
                        <span v-if="!day.isToday">{{day.text}}日</span>
                        <span v-if="day.isToday">今日</span>
                        <span v-if="day.info && day.info.desc" class="day-desc">{{day.info.desc}}</span>
                    </div>
                    <div :class="{'day-info': true, 'other-color': day.info.otherColor}"  v-if="day.info && day.info.texts && day.info.texts.length">
                        <ul class="list-unstyled">
                            <li class="day-info-item" v-for="text in day.info.texts"  v-html="text">
                                <!--{{text}}-->
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style lang='scss' scoped rel="stylesheet/scss">
    .flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .date-calendar {
        border: solid 1px #ccd2df;
        &-week-title {
            flex: 1;
            text-align: center;
        }
        &-week-line {
            height: 40px;
        }
        &-header {
            justify-content: space-between;
            text-align: center;
            &-month {
                width: 80px;
                border-radius: 3px;
                padding: 5px 15px;
                margin: 10px 15px;
                border: solid 1px #ccd2df;
                cursor: pointer;
            }
            border-bottom: solid 1px #ccd2df;
        }
        &-line {
            border-top: solid 1px #ccd2df;
            .date-calendar-day {
                flex: 1;
                height: 150px;
                width: 150px;
                border-right: solid 1px #ccd2df;
                &:last-child {
                    border-right: none;
                }
            }
        }
        .date-calendar-day {
            cursor: pointer;
            padding: 5px 10px;
            overflow-x: hidden;
            overflow-y: hidden;
            .day-info {
                color: #333;
                font-size: 10px;
                ul{
                    margin: 0;
                }
                .day-info-item {

                }
            }
            .other-color {
                color: #3dc6b6;
            }
            .day-text {
                font-size: 14px;
                font-weight: bolder;
            }
            &.today {
                .day-text {
                    color: red;
                }
            }
            &.selected, &.selected:hover{
                color: #fff;
                background-color: #5cc1b3;
            }

            &.selected  .day-info-item {
                color: #fff;
            }

            &:hover {
                background: #ffeee8
            }
            &.locked {
                cursor: default;
                background-color: #fafafa;
            }
            &.other {
            //background-color: lightgrey; color: #ccc;
            }
        }
    }
    .red {
        color: #ff4f28 !important;
    }
</style>
<script>
    import { formatDate, eventBus } from 'helpers'
    // import Day from './Day.vue'

    export default {
        components: {
            // Day
        },
        data () {
            return {
                monthInfo: {},
                today: new Date(),
                weekMap: {
                    '6': '日',
                    '0': '一',
                    '1': '二',
                    '2': '三',
                    '3': '四',
                    '4': '五',
                    '5': '六'
                },
                weekdays: [],
                weeks: [],
                month: null,
                allChecked: false
            }
        },
        props: {
            getDayInfo: {
                type: Function
            },
            lockCheck: {
                type: Function
            },
            onSingleSelect: {
                type: Function
            },
            selected: {
                type: Array,
                required: true
            },
            beforeTime: {
                'default': () => new Date()
            },
            afterTime: {
                'default': () => new Date('2100-01-01')
            },
            tagDay: {
                'default': () => new Date()
            },
            readonly: {
                type: Boolean,
                'default': false
            },
            single: {
                type: Boolean,
                'default': false
            },
            removeDisabled: {
                type: Boolean,
                'default': false
            },
            isTuan: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            buildDay (date) {
                let day = {};
                let time = day.time = new Date(date);
                day.text = time.getDate();
                day.isBefore = this.isBefore(time);
                day.isAfter = this.isAfter(time);
                day.isToday = this.isToday(time);
                day.otherMon = time.getMonth() !== this.tagDay.getMonth();
                day.checked = false;
                day.date = formatDate(day.time);
                if (this.getDayInfo) {
                    day.info = this.getDayInfo(day);
                }
                if (this.lockCheck) {
                    day.locked = this.lockCheck(day);
                }
                day.checked = this.isChecked(day);
                return day;
            },

            buildColWeek () {
                let weekdays = this.weekdays;
                this.weeks.forEach((week) => {
                    week.forEach((day, index) => {
                        let col = weekdays[index];
                        if (!col.days) {
                            col.days = [];
                        }
                        if (!day.locked) {
                            col.days.push(day);
                        }
                    });
                });
            },

            removeSelect () {
                if (this.selected && this.selected.length) {
                    this.$emit('calendar-remove-selected', this.selected)
                    this.selected.splice(0, this.selected.length);
                    this.updateMonth();
                }
            },

            selectAll () {
                let checked = this.allChecked = !this.allChecked;
                if (this.weekdays && this.weekdays.length) {
                    this.weekdays.forEach((weekday) => {
                        let index = weekday.index;
                        this.selectWeek(index, checked);
                    });
                }
            },

            isAllChecked () {
                let checked = false;
                let allLocked = true;
                if (this.weekdays && this.weekdays.length) {
                    checked = true;
                    this.weekdays.forEach((weekday) => {
                        if (!weekday.locked && !weekday.checked) {
                            checked = false;
                        }
                        if (!weekday.locked) {
                            allLocked = false;
                        }
                    });
                    if (allLocked) {
                        checked = false;
                    }
                    this.allChecked = checked;
                }
                return checked;
            },

            selectWeek (num, isChecked) {
                let checked = Boolean(isChecked);
                let col = this.weekdays[num];
                if (col && col.days && col.days.length) {
                    if (checked) {
                        col.days.forEach((day) => {
                            if (!day.locked) {
                                this.select(day);
                            }
                        });
                    } else {
                        col.days.forEach((day) => {
                            if (!day.locked) {
                                this.unSelect(day);
                            }
                        });
                    }
                }
            },

            isWeekAllSelected (weekDay) {
                let checked = false;
                let allLocked = true;
                if (weekDay && weekDay.days) {
                    checked = true;
                    weekDay.days.forEach((day) => {
                        if (!day.locked && !day.checked) {
                            checked = false;
                        }
                        if (!day.locked) {
                            allLocked = false;
                        }
                    });
                    if (allLocked) {
                        checked = false;
                        weekDay.locked = true;
                    }
                    weekDay.checked = checked;
                }
                return checked;
            },

            toggle (day) {
                let checked = this.isChecked(day);
                this.$emit('calendar-day-click', day, checked)
                if (this.readonly && !this.isTuan) return;
                if (!day.locked) {
                    if (checked) {
                        this.unSelect(day);
                    } else {
                        this.select(day);
                        if (this.onSingleSelect) {
                            this.onSingleSelect({
                                $day: day
                            });
                        }
                    }
                }
            },

            unSelect (day) {
                day.checked = false;
                if (this.isChecked(day)) {
                    let index = this.selected.indexOf(day.date);
                    this.selected.splice(index, 1);
                }
            },

            select (day) {
                day.checked = true;
                if (!this.isChecked(day)) {
                    let date = day.date;
                    this.selected.push(date);
                }
            },

            isChecked (day) {
                return Array.isArray(this.selected) && day && this.selected.indexOf(day.date) > -1;
            },


            resetMonth (date) {
                this.allChecked = false;
                this.tagDay = date || new Date();
                this.month = null;
                this.updateMonth();
            },

            // 获取一个月的信息
            updateMonth () {
                let month = formatDate(this.tagDay, 'yyyy-MM');
                if (month !== this.month) {
                    this.$emit('calendar-month-change', month)
                }
                this.month = month;
                this.weeks = this.getVisibleWeeks(this.tagDay);
                this.updateMonthInfo();
                this.weekdays = this.getWeekDays();
                this.buildColWeek();
            },

            getFirstDate (date) {
                let day = new Date(date);
                day.setDate(1);
                day.setHours(0);
                day.setMinutes(0);
                day.setSeconds(0);
                day.setMilliseconds(0);
                return day;
            },

            getWeekDays () {
                let days = [];
                for (let i = 0; i < 7; i++) {
                    days.push({
                        name: this.weekMap[i],
                        index: i
                    });
                }
                return days;
            },

            getVisibleWeeks (day) {
                let date = this.getFirstDate(day);
                let weeks = [];
                if (date.getDay() === 0) {
                    date.setDate(-5);
                } else {
                    date.setDate(date.getDate() - (date.getDay() - 1));
                }
                if (date.getDate() === 1) {
                    date.setDate(-6);
                }
                let weekNum = 0;
                while(weekNum < 6) {
                    weekNum = weekNum + 1;
                    let week = [];
                    let inMonth = false;
                    for (let i = 0; i < 7; i++) {
                        let item = this.buildDay(date);
                        if (!inMonth && !item.otherMon) {
                            inMonth = true;
                        }
                        week.push(item);
                        date.setDate(date.getDate() + 1);
                    }
                    if (inMonth) {
                        weeks.push(week);
                    }
                }
                return weeks;
            },

            updateMonthInfo () {
                let day = new Date(this.tagDay);
                let info = {
                    month: day.getMonth() + 1,
                    year: day.getFullYear()
                };
                day.setDate(1);
                day.setMonth(day.getMonth() - 1);
                info.prevMonth = day.getMonth() + 1;
                day.setMonth(day.getMonth() + 2);
                info.nextMonth = day.getMonth() + 1;
                this.monthInfo = info;
            },

            next (_delta) {
                let delta = _delta;
                let date = this.tagDay;
                date.setDate(1);
                delta = delta || 1;
                date.setMonth(date.getMonth() + delta);
                this.updateMonth();
            },

            prev (delta) {
                return this.next(-delta || -1);
            },

            isToday (date) {
                return this.dateCompare(date, this.today) === 0;
            },

            isAfter (date) {
                let after = new Date(this.afterTime);
                if (isNaN(after)) return false;
                return this.dateCompare(date, after) > 0;
            },

            isBefore (date) {
                let before = new Date(this.beforeTime);
                if (isNaN(before)) return false;
                return this.dateCompare(date, before) < 0;
            },

            dateCompare (_date1, _date2) {
                let date1 = formatDate(_date1);
                let date2 = formatDate(_date2);
                if (date1 > date2) {
                    return 1;
                } else if (date1 < date2) {
                    return -1;
                } else if (date1 === date2) {
                    return 0;
                }
                return NaN;
            }
        },
        destroyed () {
            eventBus.$off('calendar-update', this.updateFn);
            eventBus.$off('calendar-reset', this.resetFn);
        },
        mounted () {
            this.updateFn = () => {
                this.updateMonth()
            }
            this.resetFn = ($event, date) => {
                this.resetMonth(date)
            }
            this.updateMonth()
            eventBus.$on('calendar-update', this.updateFn);
            eventBus.$on('calendar-reset', this.resetFn);
        }
    }
</script>



// WEBPACK FOOTER //
// Calendar.vue?3764538c